/*
Don't change this file manually.
It is autogenerated by @plone/registry.
Instead, change the "addons" registration in the app.
*/

const projectConfigLoader = require('@root/config');
import plonevoltoSlate from '@plone/volto-slate';
import eeacmsvoltoColumnsBlock from '@eeacms/volto-columns-block';
import voltoAgsus from 'volto-agsus';

const addonsInfo = [{"name":"@plone/volto-slate","version":"18.9.1","isPublishedPackage":true,"isRegisteredAddon":false,"modulePath":"/opt/portal_agsus/volto/app/core/packages/volto-slate/src","packageJson":"/opt/portal_agsus/volto/app/core/packages/volto-slate/package.json","basePath":"/opt/portal_agsus/volto/app/core/packages/volto-slate","tsConfigPaths":null,"addons":[]},{"name":"@eeacms/volto-columns-block","version":"9.0.4","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/opt/portal_agsus/volto/app/node_modules/.pnpm/@eeacms+volto-columns-block@9.0.4_react@18.2.0/node_modules/@eeacms/volto-columns-block/src","packageJson":"/opt/portal_agsus/volto/app/node_modules/.pnpm/@eeacms+volto-columns-block@9.0.4_react@18.2.0/node_modules/@eeacms/volto-columns-block/package.json","basePath":"/opt/portal_agsus/volto/app/node_modules/.pnpm/@eeacms+volto-columns-block@9.0.4_react@18.2.0/node_modules/@eeacms/volto-columns-block","tsConfigPaths":null,"addons":[]},{"name":"volto-agsus","version":"0.1.0","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/opt/portal_agsus/volto/app/packages/volto-agsus/src","packageJson":"/opt/portal_agsus/volto/app/packages/volto-agsus/package.json","basePath":"/opt/portal_agsus/volto/app/packages/volto-agsus","tsConfigPaths":null,"addons":[]}];
export { addonsInfo };

const safeWrapper = (func) => (config) => {
  const res = func(config);
  if (typeof res === 'undefined') {
    throw new Error("Configuration function doesn't return config");
  }
  return res;
}


const projectConfig = (config) => {
  return projectConfigLoader && typeof projectConfigLoader.default === "function" ? projectConfigLoader.default(config) : config;
}

const load = (config) => {
  const addonLoaders = [plonevoltoSlate, eeacmsvoltoColumnsBlock, voltoAgsus];
  if(!addonLoaders.every((el) => typeof el === "function")) {
    throw new TypeError(
      'Each addon has to provide a function applying its configuration to the projects configuration.',
    );
  }
  return projectConfig(addonLoaders.reduce((acc, apply) => safeWrapper(apply)(acc), config));
};
export default load;
